import {NewsItem, Session, User} from "../types/Types";
import React from "react";
import {addAnchorTags} from "../util/Util";
import UserTag from "../users/tag/UserTag";
import DateTime from "../date/DateTime";
import LocationTag from "../tag/LocationTag";
import LikeButton from "../tag/likes/LikeButton";

interface Props {
    newsItem: NewsItem;
    user: User | undefined;
    session: Session | undefined;
    currentUser?: User;
    likesMap?: Map<string, boolean>;
    onLikeCountChange?: (commentId: string, adjustment: number) => void;
}

function NewsItemRow(props: Props) {

    const getNewsContent = (newsItem: NewsItem): string => {
        let news = "";

        if(newsItem.type === 'VISIT') {
            news = " ticked ";
        } if(newsItem.type === 'VISIT' && newsItem.verified) {
            news = " visited ";
        } else if(newsItem.type === 'LOCATION' && newsItem.subType === 'UPDATE') {
            news = " updated ";
        } else if(newsItem.type === 'LOCATION' && newsItem.subType === 'CREATION') {
            news = " added ";
        } else if(newsItem.type === 'COMMENT') {
            news = " commented on "
        }

        return news;
    };

    const getTabToLinkTo = (newsItem: NewsItem): string => {
        let tab = "";
        if(newsItem.type === 'COMMENT') {
            tab = "comments"
        } else {
            tab = "visits"
        }
        return tab;
    };

    if (props.newsItem.type === 'COMMENT') {
        return (
            <div className={"news-item comment-news-item"}>
                <div className={"comment-bubble"}>
                    <span className={"comment-bubble-content"} dangerouslySetInnerHTML={{ __html: addAnchorTags(props.newsItem.payload)}} />
                </div>

                <div className={"comment-meta-row"}>
                    <div className={"comment-meta-copy"}>
                        <div className={"d-inline-block"}>
                            {props.user && <UserTag user={props.user} visit={undefined} session={props.session} padRight={false} hideLocationDot={false} linksToTab={getTabToLinkTo(props.newsItem)}/>}
                        </div>
                        <div className={"d-inline-block mr-1"}>
                            {getNewsContent(props.newsItem)}
                        </div>
                        <LocationTag
                            name={props.newsItem.locationName}
                            id={props.newsItem.locationId}
                            displayVerificationTag={props.newsItem.verified}
                            session={props.session}
                            linksToTab={getTabToLinkTo(props.newsItem)}
                        />
                    </div>
                </div>

                <div className={"comment-action-row"}>
                    <div>
                        {props.currentUser && props.likesMap && (
                        <LikeButton
                            entityId={props.newsItem.id}
                            likeType="COMMENT"
                            initialLikeCount={props.newsItem.likeCount || 0}
                            isLiked={props.likesMap.get(props.newsItem.id) || false}
                            currentUser={props.currentUser}
                            locationId={props.newsItem.locationId}
                            locationName={props.newsItem.locationName}
                            onLikeCountChange={props.onLikeCountChange}
                        />
                        )}
                    </div>
                    <DateTime date={props.newsItem.lastModified}/>
                </div>
            </div>
        )
    }

    return (
        <>
            {<div className={"news-item"}>

                <div>
                    <div className={"d-inline-block"}>
                        {props.user && <UserTag user={props.user} visit={undefined} session={props.session} padRight={false} hideLocationDot={false} linksToTab={getTabToLinkTo(props.newsItem)}/>}
                    </div>
                    <div className={"d-inline-block mr-1"}>
                        {getNewsContent(props.newsItem)}
                    </div>
                    <LocationTag
                        name={props.newsItem.locationName}
                        id={props.newsItem.locationId}
                        displayVerificationTag={props.newsItem.verified}
                        session={props.session}
                        linksToTab={getTabToLinkTo(props.newsItem)}
                    />
                </div>

                <div className={"mt-1"} style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <div style={{display: "flex", alignItems: "center", gap: "0.5em"}}>
                        {props.newsItem.type === 'VISIT' &&
                        <div style={{float: "left"}}>
                            <small>
                                <>
                                    {(Number(props.newsItem.payload).toString() !== 'NaN' &&
                                        Number(props.newsItem.payload).toString() !== '0')
                                    && <div className={"d-inline-block mr-1"}>
                                        Visit number {Number(props.newsItem.payload).toString()}
                                    </div>}
                                    {(Number(props.newsItem.payload).toString() === 'NaN' &&
                                        Number(props.newsItem.payload).toString() !== '0')
                                    && <div className={"d-inline-block mr-2"}>
                                        Visit number 1
                                    </div>}
                                </>
                            </small>
                        </div>}
                    </div>

                    <DateTime date={props.newsItem.lastModified}/>
                </div>
            </div>}
        </>
    )
}

export default NewsItemRow;
